import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { fontSize } from '@mui/system';
import { API_URL } from '../../Constants';

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#BADEC1',
    },
});

const handleCommerceLogin = () => {

    let apiUrl = API_URL;

    let documentNumber = document.getElementById("documentNumber").value;
    if (documentNumber != "") {
        fetch(apiUrl + '/v1/commerces/document/NIT/' + documentNumber, {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    localStorage.setItem("commerceUuid", res.uuid);
                    window.location = '/commerce';
                })
            } else {
                console.log("Commerce doesn´t exist");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });
    }

}



export default function LoginCommerce() {
    return (
        <React.Fragment>
            <Header isLoggedIn={false}/>
            <Box sx={{marginTop: '10vh'}}>
                <Container maxWidth="md">
                    <br />
                    <br />
                    <br />
                    <Box sx={{ flexGrow: 1, margin: 'auto 1rem'}}>
                        <Grid container spacing={3}>
                            <Grid item xs />
                            <Grid item xs={7}>
                                <Stack spacing={9}>
                                    <h1 style={{ fontSize: 50, textAlign: 'center' }}>Ingreso Comercios</h1>
                                    <TextField id="documentNumber" label="NIT" variant="outlined" />
                                    
                                    <ButtonPrincipal variant="contained" onClick={handleCommerceLogin}>Ingresar</ButtonPrincipal>
                                </Stack>
                            </Grid>
                            <Grid item xs />
                        </Grid>
                    </Box>
                </Container>
            </Box>
        </React.Fragment>
    );
}